<div class="dropdown-checkbox">
  <div class="dropdown-checkbox-header">
    <ion-label>{{'Filter' | translation}}</ion-label>
  </div>
  <ion-list>
    <ion-checkbox *ngFor="let item of items" [checked]="isSelected(item)" (ionChange)="toggleItem(item)">
      {{ item }}
    </ion-checkbox>
  </ion-list>
  <ion-item>
    <ion-button expand="full" color="medium" (click)="clearSelection()">{{ 'Clear' | translation }}</ion-button>
  </ion-item>
</div>